import { getLocalizedValue } from "helpers/language-helper";
import { useTranslation } from "react-i18next";

/**
 * React hook that extracts the localized string from a multilingual object and reactively
 * updates when the language changes.
 *
 * Use this inside React components instead of getLocalizedValue to ensure the value
 * re-evaluates when the user switches language.
 *
 * @param multiLangObj - Object with BCP 47 language codes as keys and translations as values
 * @param fallbackLang - Fallback language if current language not found (defaults to 'sv-SE')
 * @returns Localized string or empty string if not found
 */
function useLocalizedValue(
    multiLangObj: { [key: string]: string } | undefined,
    fallbackLang: string = "sv-SE"
): string {
    useTranslation(); // Subscribes to language changes, ensuring re-render on language switch
    return getLocalizedValue(multiLangObj, fallbackLang);
}

export { useLocalizedValue };
